export default "__VITE_ASSET__97c41ce9__"